import httpUtils from '../../utils/HttpUtils'

class DealerCouponService {

  //获取店铺列表信息
  async detail(couponCode = '') {
    let result = null;
    try {
      result = await httpUtils.post('/mall/dealer/coupon/detailByCode', { couponCode })
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }
  async verifyCoupon({couponCode, verifierId }) {
    let result = null;
    try {
      result = await httpUtils.post('/mall/dealer/coupon/verify/coupon', { couponCode, verifierId })
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }
}
export default new DealerCouponService()
